// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kit-tabs .e-tabs .tab-content{padding-bottom:0}.kit-tabs .e-tabs .tab-content,.kit-tabs .e-tabs .tab-content>div{display:flex;flex-direction:column;height:calc(100vh - 45px);overflow:hidden}.kit-tabs .e-tabs__item{display:flex;min-width:100px;padding:.5rem 1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
